import * as React from 'react';
import styled from 'styled-components';
import { color, space } from 'styled-system';
import { StyledSystemProps } from '../theme/StyledSystemProps';

export enum StatusValues {
  New = 'NEW',
  Archived = 'ARCHIVED',
  Active = 'ACTIVE',
  Preapproved = 'PREAPPROVED',
  Approved = 'APPROVED',
  DRAFT = 'DRAFT',
  Paid = 'PAID',
  Public = 'PUBLIC',
  Published = 'PUBLISHED',
  Invitee = 'INVITEE',
  Purchased = 'PURCHASED',
  Attending = 'ATTENDING',
  notAttending = 'NOT ATTENDING',
  Accepted = 'ACCEPTED',
  Sold = 'SOLD',
  Pending = 'PENDING',
  Occupied = 'OCCUPIED',
  Delivering = 'DELIVERED',
  Successful = 'SUCCESSFUL',
  OnRoute = 'ON_ROUTE',
  Confirmed = 'CONFIRMED',
}

const StyledBadge = styled.span<BadgeProps>`
  ${color}
  ${space};
  color: #ffffff;
  font-size: 14px;
  font-weight: 400;
  border-radius: 4px;
  text-transform: uppercase;
`;

type BadgeProps = StyledSystemProps & {
  value?: StatusValues | string;
  color?: string;
};

const Badges: React.FC<BadgeProps> = ({ value }: { value: StatusValues }) => {
  if (
    value === 'ACTIVE' ||
    value === 'DELIVERED' ||
    value === 'APPROVED' ||
    value === 'PAID' ||
    value === 'PUBLISHED' ||
    value === 'PURCHASED' ||
    value === 'SUCCESSFUL' ||
    value === 'ACCEPTED' ||
    value === 'ATTENDING'
  ) {
    return (
      <StyledBadge px={2} py={1} bg="success">
        {value}
      </StyledBadge>
    );
  } else if (
    value === 'NEW' ||
    value === 'ON_ROUTE' ||
    value === 'CONFIRMED' ||
    value === 'DRAFT' ||
    value === 'PENDING' ||
    value === 'OCCUPIED'
  ) {
    return (
      <StyledBadge px={2} py={1} bg="blue">
        {value}
      </StyledBadge>
    );
  } else if (value === 'PREAPPROVED' || value === 'INVITEE') {
    return (
      <StyledBadge px={2} py={1} bg="pending">
        {value}
      </StyledBadge>
    );
  } else {
    return (
      <StyledBadge px={2} py={1} bg="red">
        {value}
      </StyledBadge>
    );
  }
};

export default Badges;



// WEBPACK FOOTER //
// ./src/components/Badges.tsx